var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ev-inventory-target-panel')
}
var staticRenderFns = []

export { render, staticRenderFns }